module.exports = __webpack_public_path__ + "media/9.6474523d.wav";